module.exports = __webpack_public_path__ + "res/Roboto-Medium-webfont.ttf?108f70b8633879b488878e45b02f87e3";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Medium-webfont.ttf
// module id = 74
// module chunks = 0